import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BalanceteComponent } from './balancete.component';
import { AuthGuard } from 'eddydata-lib';

const routes: Routes = [
  { path: '', component: BalanceteComponent, canActivate: [AuthGuard] }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BalanceteRoutingModule { }
